const SECTIONS = [
  { h: "Personal License", b: "For non-commercial use: personal social media, home display, editing practice, and non-monetised projects. Single user, worldwide, in perpetuity. May not be resold, sub-licensed, or used to promote a business." },
  { h: "Commercial License", b: "For business and monetised use: advertising, broadcast, film & TV, web and app backgrounds, and client work. Includes worldwide rights across digital and broadcast media. Duration and territory can be tailored — contact the studio for exclusive or buy-out terms." },
  { h: "What you receive", b: "On purchase you get a download link to the high-resolution deliverable. Commercial licenses include the license certificate with the terms, territory and media type recorded against your order." },
  { h: "Prints", b: "Fine-art prints are a physical product fulfilled by Miller's Professional Imaging. Purchasing a print does not transfer any reproduction or license rights to the underlying image." },
  { h: "Refunds", b: "Digital licenses are non-refundable once delivered. Print orders may be refunded or reprinted if they arrive damaged or defective — contact the studio within 14 days." },
];

export default function Licensing() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="overline-label mb-3">Terms</div>
      <h1 className="font-serif text-5xl lg:text-6xl font-light">Licensing</h1>
      <div className="mt-10 space-y-10">
        {SECTIONS.map((s) => (
          <div key={s.h} className="border-l border-amber-glow/40 pl-6">
            <h2 className="font-serif text-2xl font-light">{s.h}</h2>
            <p className="mt-2 text-neutral-400 leading-relaxed">{s.b}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
